/**
 * Old task links pointed to /dashboard?task=<taskId> (or /workspaces?task=<taskId>), tasks now live on /tasks/<taskId>
 */
export const taskSearchParamRedirect = (location) => {
    const searchParams = new URLSearchParams(location.search);
    const taskId = searchParams.get('task');
    if (!taskId) {
        return undefined;
    }
    searchParams.delete('task');
    return Object.assign(Object.assign({}, location), { pathname: `/tasks/${encodeURIComponent(taskId)}`, search: searchParams.toString() });
};
export const workspaceToDashboardRedirect = (routeProps) => {
    const { location } = routeProps;
    return (taskSearchParamRedirect(location) || Object.assign(Object.assign({}, location), { pathname: '/dashboard' }));
};
export const workspaceToFilesRedirect = (routeProps) => {
    const { location, match } = routeProps;
    const { folderId } = match.params;
    const options = Object.assign(Object.assign({}, location), { pathname: '/files' });
    if (folderId) {
        Object.assign(options, { pathname: `/files/${folderId}` });
    }
    return options;
};
